import type { AppPaneName } from 'owa-app-pane-group-types';
import { appPaneNames } from 'owa-app-pane-group-types';

const appPaneNamesSet = new Set<string>(appPaneNames);

export default function isAppPane(paneName: string): paneName is AppPaneName {
    return appPaneNamesSet.has(paneName);
}
